export const DAY_TABS = [
  { key: 'hoje', label: 'Hoje' },
  { key: 'amanha', label: 'Amanhã' },
  { key: 'depoisDeAmanha', label: 'Depois de amanhã' },
]

export const CONTACT_STATUS_OPTIONS = {
  'pendente': 'Pendente',
  'confirmado': 'Confirmado',
  'reagendado': 'Reagendado',
  'sem_resposta': 'Sem resposta',
}

export const DISABLED_STATUS_OPTIONS = {
  'finalizado': 'FINALIZADO',
  'cancelado': 'CANCELADO',
}



export const TABLE_NAME = 'central-agendamentos'
